import { useMemo } from 'react';

import { NameAndCreateDateFormatter, HeaderRPUImpresisonsFormatter, RPUFormatter, keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, duplicateWithNameAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import DetailsFormatter from './DetailsFormatter';
import ReportLink from './ReportLink';
import RulesFormatter from './RulesFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { size: 300 }),
    column.accessor('rules', {
      header: 'Rules',
      cell: info => <RulesFormatter info={info} />,
      size: 80,
    }),
    column.accessor('type', {
      header: 'Type',
      cell: info => <DetailsFormatter info={info} />,
      size: 200,
    }),
    column.accessor('impressions', {
      header: () => <HeaderRPUImpresisonsFormatter title='Impressions' />,
      cell: info => info.getValue() || 0,
      enableSorting: false,
    }),
    column.accessor('rpu', {
      header: () => <HeaderRPUImpresisonsFormatter title='RPU' />,
      cell: info => <RPUFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateWithNameAction, reportLinkAction),
  ], [])
}

function reportLinkAction(info) {
  return <ReportLink key={keyOf(info, 'report-link')} info={info} />
}
